export class CoreConfig {
  public static readonly API_BASE_URL = 'apiBaseUrl';
  public static readonly LOCAL_CONFIG = 'localConfig';
  public static readonly SOCKET_IO_PATH = 'socketIo';
  public static readonly SOCKET_ROOM = 'room';
}
